import React, { useState } from 'react'
import './contact.css'
import Navigation from '../../Component/Navigation/Navigation'
import Footer from '../../Component/Footer/Footer'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import { useAuthContext } from '../../Hooks/useAuthContext'

function Contact() {
  const [NLEmail, setNLEmail]         = useState(null)
  const [name, setName]               = useState('')
  const [email, setEmail]             = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [subject, setSubject]         = useState('')
  const [message, setMessage]         = useState('')
  const [buttonState, setButtonState] = useState('Submit')
  const { user }                      = useAuthContext()

  const handleNLSubmit = (e) => {
    e.preventDefault()
    if (!NLEmail) toast.error('Enter an Email')
    else toast.success('News Letter Signup Successful')
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setButtonState('Processing...')
    const data = { name, email, phoneNumber, subject, message }
    console.log(data)

    axios.post(`${process.env.REACT_APP_BACKEND_URL}/admin/send-email`, data, {
      headers: {
        Authorization: `Bearer ${user.token}`,
        'Content-Type': 'application/json',
      },
    }).then(() => {
      toast.success('Message Submitted Successfully')
      setName(''); setEmail(''); setPhoneNumber('')
      setSubject(''); setMessage('')
      setButtonState('Submit')
    }).catch(error => {
      toast.error(error.response.data.error)
      setButtonState('Submit')
    })
  }

  const promises = [
    {
      icon: (
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      ),
      title: 'Secure & Confidential',
      text: 'Your data and message are protected end-to-end.',
    },
    {
      icon: (
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="12 6 12 12 16 14"/>
        </svg>
      ),
      title: 'Fast Response',
      text: 'Our team typically responds within one business day.',
    },
    {
      icon: (
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: 'Dedicated Support',
      text: 'You speak directly to a real member of our team.',
    },
  ]

  return (
    <div className="ct-page">
      <ToastContainer />
      <Navigation />

      {/* ── Header ──────────────────────────────────────────── */}
      <div className="ct-header">
        <div className="ct-header__content">
          <h1 className="ct-header__title">Contact Us</h1>
          <p className="ct-header__breadcrumb">Home &nbsp;/&nbsp; Contact Us</p>
        </div>
      </div>

      {/* ── Contact info strip ──────────────────────────────── */}
      <div className="ct-info">
        <div className="ct-info__grid">
          <div className="ct-info__item">
            <div className="ct-info__icon">
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <div className="ct-info__text">
              <strong>Email Address</strong>
              <span><a href="mailto:info@nextwavesfinsedge.com">info@nextwavesfinsedge.com</a></span>
            </div>
          </div>

          <div className="ct-info__item">
            <div className="ct-info__icon">
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <div className="ct-info__text">
              <strong>Response Time</strong>
              <span>Within one business day</span>
            </div>
          </div>

          <div className="ct-info__item">
            <div className="ct-info__icon">
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <div className="ct-info__text">
              <strong>Privacy</strong>
              <span>End-to-end encrypted</span>
            </div>
          </div>
        </div>
      </div>

      {/* ── Main section ────────────────────────────────────── */}
      <div className="ct-main">
        <div className="ct-main__inner">

          {/* Left — form */}
          <div>
            <div className="ct-form-head">
              <span className="ct-eyebrow">Get in Touch</span>
              <h2>Send us a <em>message</em></h2>
              <p>Fill in the form below and a member of our team will get back to you promptly.</p>
            </div>

            <div className="ct-form-card">
              <div className="ct-form-card__bar" />
              <div className="ct-form-card__body">

                <div className="ct-row">
                  <div className="ct-field">
                    <label>Full Name</label>
                    <input
                      type="text"
                      placeholder="Your name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="ct-field">
                    <label>Email Address</label>
                    <input
                      type="email"
                      placeholder="Your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="ct-row">
                  <div className="ct-field">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      placeholder="Phone number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </div>
                  <div className="ct-field">
                    <label>Subject</label>
                    <input
                      type="text"
                      placeholder="Subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                </div>

                <div className="ct-field">
                  <label>Message</label>
                  <textarea
                    placeholder="Type your message here…"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>

                <div className="ct-submit">
                  <button
                    className="ct-btn ct-btn--navy"
                    onClick={handleSubmit}
                    disabled={buttonState === 'Processing...'}
                  >
                    {buttonState === 'Processing...' ? 'Processing…' : 'Send Message →'}
                  </button>
                </div>

              </div>
            </div>
          </div>

          {/* Right — detail panel */}
          <div className="ct-detail">
            <div className="ct-detail__intro">
              <span className="ct-eyebrow">Contact Details</span>
              <h3>We're here to <em>help</em></h3>
              <p>
                Whether you have a question about your account, need support with a
                transaction, or simply want to learn more about our services — we're
                just a message away.
              </p>
            </div>

            <div className="ct-promises">
              {promises.map((p, i) => (
                <div className="ct-promise" key={i}>
                  <div className="ct-promise__icon">{p.icon}</div>
                  <div className="ct-promise__text">
                    <h4>{p.title}</h4>
                    <p>{p.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="ct-email-card">
              <div className="ct-email-card__icon">
                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className="ct-email-card__text">
                <strong>Direct Email</strong>
                <a href="mailto:info@nextwavesfinsedge.com">info@nextwavesfinsedge.com</a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Newsletter ──────────────────────────────────────── */}
      <div className="ct-newsletter">
        <div className="ct-newsletter__inner">
          <div className="ct-newsletter__text">
            <h2>Subscribe to Receive Latest Updates</h2>
            <p>Stay informed with our latest news, offers, and financial insights.</p>
          </div>
          <form className="ct-newsletter__form" onSubmit={handleNLSubmit}>
            <input
              type="email"
              placeholder="Your Email"
              onChange={(e) => setNLEmail(e.target.value)}
            />
            <input type="submit" value="Subscribe" />
          </form>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Contact